import {
  Avatar,
  Box,
  Button,
  Skeleton,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PromoCodeData, PromotionDropdownItems } from "../../../Helper";
import { useGetPromoCodeByID } from "../../../store/Apis/StripeApi";
import "./ViewPromoCode.css";
import LinearProgress from "@mui/material/LinearProgress";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import {
  formatDate,
  stringAvatar,
} from "../../../store/one-query/useMethodHelper";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { PointIcon } from "../../../Custom-imeges/PromoCodesIcons/PointIcon";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { EditPromoCode } from "../../UpdatePromoCode/components/EditPromoCode";

export const ViewPromoCode = () => {
  const [openEditPromo, setOpenEditPromo] = useState(false);
  const [isPromoUpdated, setIsPromoUpdated] = useState(false);

  const { id: PromoCodeId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [PromoCodeData, setPromoCodeData] = useState<PromoCodeData>();
  const {
    mutate: GetPromoCodeByIdRequest,
    isSuccess: isGetPromoSuccess,
    data: PromoCodeResponse,
    isPending: isGetPromoLoading,
  } = useGetPromoCodeByID();

  const steps = [
    { label: "Created:", description: formatDate(PromoCodeData?.createdAT) },
    {
      label: "Last updated:",
      description: PromoCodeData?.lastUpdate
        ? formatDate(PromoCodeData?.lastUpdate)
        : "---------------",
    },
  ];

  useEffect(() => {
    if (PromoCodeId) {
      GetPromoCodeByIdRequest(PromoCodeId);
    }
  }, [PromoCodeId]);

  // Get promoCode updated date after updating.
  useEffect(() => {
    if (isPromoUpdated && PromoCodeId) {
      GetPromoCodeByIdRequest(PromoCodeId);
    }
  }, [isPromoUpdated]);

  useEffect(() => {
    if (PromoCodeResponse && isGetPromoSuccess) {
      setPromoCodeData(PromoCodeResponse);
      setIsPromoUpdated(false);
    }
  }, [isGetPromoSuccess, PromoCodeResponse]);

  const handleCloseViewPromoCode = () => {
    navigate("/admin/manage-coupons");
  };

  const handleOpenEditPromo = (open: boolean) => {
    setOpenEditPromo(open);
  };

  const handleOpenEditPromoClick = () => {
    setOpenEditPromo(true);
  };

  const handleUpdatePromoCodeStatus = () => {
    setIsPromoUpdated(true);
  };
  return (
    <>
      <Box className="promoCode-body-container">
        <Box className="promoCode-body-header justify-content-between">
          <Box className="view-promo-heder-details" sx={{ width: "80%" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {isGetPromoLoading ? (
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={160}
                  height={33}
                  sx={{ bgcolor: "#2a2c33" }}
                />
              ) : (
                <Typography className="page-header-main-title">
                  {PromoCodeData?.code}
                </Typography>
              )}
              {isGetPromoLoading ? (
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={100}
                  height={25}
                  sx={{ bgcolor: "#2a2c33" }}
                />
              ) : (
                <Typography className="page-header-name-title">
                  {`(${PromoCodeData?.codeName})`}
                </Typography>
              )}
            </Box>
            <Box className="header-description" sx={{ mt: 1 }}>
              {isGetPromoLoading ? (
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={500}
                  height={25}
                  sx={{ bgcolor: "#2a2c33" }}
                />
              ) : (
                <Typography
                  className="page-header-name-title"
                  sx={{ opacity: "0.6" }}
                >
                  {PromoCodeData?.description}
                </Typography>
              )}
            </Box>
          </Box>
          <Box className="view-bromo-btns-actions">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                gap: "1rem",
              }}
            >
              {isGetPromoLoading ? (
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={130}
                  height={70}
                  sx={{ bgcolor: "#2a2c33" }}
                />
              ) : (
                <Button
                  className="edit-promo-btn"
                  variant="contained"
                  sx={{
                    width: "100%",
                    textTransform: "inherit",
                    padding: "6px 35px",
                    borderRadius: "10px !important",
                  }}
                  onClick={handleOpenEditPromoClick}
                >
                  Edit
                </Button>
              )}
              {isGetPromoLoading ? (
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={130}
                  height={70}
                  sx={{ bgcolor: "#2a2c33" }}
                />
              ) : (
                <Button
                  className="create-promo-btn"
                  variant="contained"
                  sx={{
                    width: "100%",
                    textTransform: "inherit",
                    padding: "6px 35px",
                    borderRadius: "10px !important",
                  }}
                  onClick={handleCloseViewPromoCode}
                >
                  Close
                </Button>
              )}
            </Box>
          </Box>
        </Box>
        <Box className="promoCode-body-content">
          <Box
            className="promoCode-body-left-side"
            sx={{
              paddingTop: "40px !important",
              gap: !isGetPromoLoading ? "2rem" : "0",
              marginBottom: "15rem",
            }}
          >
            {isGetPromoLoading ? (
              <Skeleton
                animation="wave"
                variant="text"
                width={150}
                height={70}
                sx={{ bgcolor: "#2a2c33" }}
              />
            ) : (
              <Box className="discount-percentage">
                <Box
                  className="value-box"
                  sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <Typography className="value">
                    {PromotionDropdownItems[
                      PromoCodeData?.promotionType || 0
                    ] !== "Life Time"
                      ? PromoCodeData?.promotionValue
                      : null}
                  </Typography>
                  <Typography className="value-mark">
                    {PromoCodeData?.promotionType !== 0 &&
                    PromotionDropdownItems[
                      PromoCodeData?.promotionType || 0
                    ] === "Flat Amount Off"
                      ? "$"
                      : PromoCodeData?.promotionType !== 0 && "%"}
                  </Typography>
                </Box>
                <Box
                  className={`text ${
                    PromoCodeData?.promotionType === 0 && "life-time"
                  }`}
                >
                  {PromoCodeData?.promotionType === 0 ? (
                    "Life-Time"
                  ) : PromotionDropdownItems[
                      PromoCodeData?.promotionType || 0
                    ] === "Flat Amount Off" ? (
                    <>
                      Flat Amount <br /> Off
                    </>
                  ) : (
                    <>
                      Percentage <br /> Off
                    </>
                  )}
                </Box>
              </Box>
            )}
            {isGetPromoLoading ? (
              <Skeleton
                animation="wave"
                variant="text"
                width={440}
                height={200}
                sx={{ bgcolor: "#2a2c33" }}
              />
            ) : (
              <Box className="usage-statistics">
                <Box className="usage-header">
                  <Box className="usage-statistics-title">Usage statistics</Box>
                  {PromoCodeData?.used && PromoCodeData?.used > 0 ? (
                    <Box
                      className="view-users"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <Typography className="view-users-text">
                        View users
                      </Typography>
                      <ArrowOutwardIcon
                        sx={{ color: "#12b6ea", fontSize: "1.3rem" }}
                      />
                    </Box>
                  ) : null}
                </Box>
                <Box className="usage-statistics-details">
                  <Box className="usage-statistics-details-total">
                    <Typography className="details-total-main-title">
                      Total Uses
                    </Typography>
                    <Typography
                      className={`details-total-value ${
                        PromoCodeData?.unLimitedFlag && "unlimited"
                      }`}
                    >
                      {PromoCodeData?.unLimitedFlag && !PromoCodeData?.totalUses
                        ? "Unlimited"
                        : PromoCodeData?.totalUses}
                    </Typography>
                  </Box>
                  <Box
                    className={`usage-statistics-details-used ${
                      PromoCodeData?.unLimitedFlag && "align-items-center"
                    }`}
                  >
                    <Typography className="details-total-title">
                      Used
                    </Typography>
                    <Typography className="details-used-value">
                      {PromoCodeData?.used}
                    </Typography>
                  </Box>
                  {!PromoCodeData?.unLimitedFlag && (
                    <Box className="usage-statistics-details-remaining">
                      <Typography className="details-total-title">
                        Remaining
                      </Typography>
                      <Typography className="details-remaining-value">
                        {PromoCodeData?.totalUses &&
                          PromoCodeData?.totalUses - PromoCodeData?.used}
                      </Typography>
                    </Box>
                  )}
                </Box>
                {!PromoCodeData?.unLimitedFlag && (
                  <Box className="usage-statistics-progress">
                    <LinearProgress
                      variant="determinate"
                      value={
                        PromoCodeData?.totalUses &&
                        (PromoCodeData?.used / PromoCodeData?.totalUses) * 100
                      }
                      sx={{
                        height: "9px",
                        alignSelf: "stretch",
                        borderRadius: "16px",
                        backgroundColor: "#22262F",
                        "& .MuiLinearProgress-bar": {
                          borderRadius: "16px",
                          backgroundColor: "#12B6EA",
                        },
                      }}
                    />
                  </Box>
                )}
              </Box>
            )}
            {isGetPromoLoading ? (
              <Skeleton
                animation="wave"
                variant="text"
                width={440}
                height={100}
                sx={{ bgcolor: "#2a2c33" }}
              />
            ) : (
              <Box className="expiration-box">
                <Typography className="box-title">Duration</Typography>
                <Box className="expiration-dates">
                  <Box className="date">
                    <Box className="date-name">
                      {PromoCodeData?.durationById}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
            {isGetPromoLoading ? (
              <Skeleton
                animation="wave"
                variant="text"
                width={440}
                height={100}
                sx={{ bgcolor: "#2a2c33" }}
              />
            ) : (
              <Box className="expiration-box">
                <Typography className="box-title">Subscription type</Typography>
                <Box className="expiration-dates">
                  <Box className="date">
                    <Box className="date-name">
                      {PromoCodeData?.subscriptionType}
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
            {isGetPromoLoading ? (
              <Skeleton
                animation="wave"
                variant="text"
                width={440}
                height={100}
                sx={{ bgcolor: "#2a2c33" }}
              />
            ) : (
              <Box className="expiration-box">
                <Typography className="box-title">Expiration date</Typography>
                <Box className="expiration-dates">
                  <Box className="date">
                    <Box className="date-name">
                      {PromoCodeData?.expireAt
                        ? formatDate(PromoCodeData?.expireAt)
                        : "No expired date"}
                    </Box>
                    {PromoCodeData?.expireAt && (
                      <Box className="expired-clock">
                        <Typography className="expired-clock-text">
                          11:59 PM
                        </Typography>
                        <AccessTimeIcon sx={{ fontSize: "1rem" }} />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            )}
            {isGetPromoLoading ? (
              <Skeleton
                animation="wave"
                variant="text"
                width={300}
                height={150}
                sx={{ bgcolor: "#2a2c33" }}
              />
            ) : (
              <Box className="restrictions-box">
                <Typography className="box-title">Restrictions</Typography>
                <Box className="restrictions">
                  <Box className="restriction">Single Use Only</Box>
                  <Box className="restriction">New Users Only</Box>
                </Box>
              </Box>
            )}
            {isGetPromoLoading ? (
              <Skeleton
                animation="wave"
                variant="text"
                width={440}
                height={100}
                sx={{ bgcolor: "#2a2c33" }}
              />
            ) : (
              <Box className="created-by-box">
                <Typography className="box-title">Created by</Typography>
                <Box className="users">
                  <Box className="user">
                    <Box className="user-image">
                      {PromoCodeData?.imageUrl ? (
                        <Avatar
                          src={PromoCodeData?.imageUrl || undefined}
                          sx={{ width: 35, height: 35, fontSize: "14px" }}
                        />
                      ) : !PromoCodeData?.imageUrl &&
                        PromoCodeData?.createdBy ? (
                        <Avatar
                          {...stringAvatar(PromoCodeData?.createdBy)}
                          sx={{ width: 35, height: 35, fontSize: "14px" }}
                        />
                      ) : null}
                    </Box>
                    <Box className="user-name">{PromoCodeData?.createdBy}</Box>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
          <Box className="promoCode-body-right-side">
            {isGetPromoLoading ? (
              <Skeleton
                animation="wave"
                variant="text"
                width={125}
                height={200}
                sx={{ bgcolor: "#2a2c33" }}
              />
            ) : (
              <Box className="creation-details position-relative">
                <Box sx={{ maxWidth: 400 }}>
                  <Stepper
                    activeStep={-1}
                    orientation="vertical"
                    sx={{
                      "& .MuiStepConnector-line": {
                        minHeight: "51px",
                      },
                      "& .css-1afu6qk-MuiStepConnector-root": {
                        marginLeft: "3px",
                        opacity: "0.1",
                      },
                    }}
                  >
                    {steps.map((step, index) => (
                      <Step key={step.label}>
                        <StepLabel
                          icon={<PointIcon />}
                          sx={{
                            "& .MuiStepIcon-root": { display: "none" },
                            "& .MuiStepLabel-label": {
                              color: "#fff",
                              opacity: "0.9",
                              fontSize: "14px",
                              fontWeight: "500",
                            },
                          }}
                        >
                          <CalendarTodayIcon
                            sx={{ fontSize: "1.2rem", paddingRight: "4px" }}
                          />
                          {step.label}
                        </StepLabel>

                        <Typography
                          sx={{
                            pl: 4,
                            fontSize: "14px",
                            color: "#fff",
                            opacity: "0.6",
                            position: "absolute",
                          }}
                        >
                          {step.description}
                        </Typography>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <EditPromoCode
        open={openEditPromo}
        setOpen={handleOpenEditPromo}
        codeName={PromoCodeData?.codeName || ""}
        codeId={PromoCodeData?.promoCodeId || ""}
        setIsPromoUpdated={handleUpdatePromoCodeStatus}
        codeDescription={PromoCodeData?.description || ""}
      />
    </>
  );
};
